<div [formGroup]="ColumnForm">
  <div class="column-header">
    <h2>Select Report Columns</h2>
    <button mat-icon-button aria-label="Close" mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <div class="btn-row">
    <div class="options-direction">Choose the columns you want to include in your report:</div>
    <button aria-label="clear" class="usa-button usa-button--secondary clear-btn"
      (click)="clearSelection()"><mat-icon>close</mat-icon>Clear
      Selections</button>
  </div>
  <div class="options">
    <h3 class="options-header">Location</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="region">
        Region
      </mat-checkbox>
      <mat-checkbox formControlName="forest_name">
        Forest
      </mat-checkbox>
      <mat-checkbox formControlName="forest_org_code">
        ForestOrgCode
      </mat-checkbox>
      <mat-checkbox formControlName="IRWIN_POO_state">
        State of Fire Origin
      </mat-checkbox>
      <mat-checkbox formControlName="ranger_district">
        Ranger District
      </mat-checkbox>
      <mat-checkbox formControlName="IRWIN_POO_county">
        Counties
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">Date</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="calendar_year">
        Calendar Year
      </mat-checkbox>
      <mat-checkbox formControlName="fiscal_year">
        Fiscal Year
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">Fire Details</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="baer_name">
        Fire/Complex Name
      </mat-checkbox>
      <mat-checkbox formControlName="fire_start_date">
        Fire Start Date
      </mat-checkbox>
      <mat-checkbox formControlName="IRWIN_unique_fire_identifier">
        Fire Number
      </mat-checkbox>
      <mat-checkbox formControlName="job_code">
        Fire Incident Job Code
      </mat-checkbox>
      <mat-checkbox formControlName="total_fire_acres">
        Total Fire Acres
      </mat-checkbox>
      <mat-checkbox formControlName="source">
        Source
      </mat-checkbox>
      <mat-checkbox formControlName="acres_fsonly">
        Est. NFS Acres
      </mat-checkbox>
      <mat-checkbox formControlName="fire_complexity">
        Complexity
      </mat-checkbox>
      <mat-checkbox formControlName="containment_date_est">
        Est. Containment Date
      </mat-checkbox>
      <mat-checkbox formControlName="containment_date">
        Containment Date (GIS)
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">BAER Assessments</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="assessment_status">
        Assessment Status
      </mat-checkbox>
      <mat-checkbox formControlName="team_lead">
        Team Lead
      </mat-checkbox>
      <mat-checkbox formControlName="team_needs">
        Team Needs
      </mat-checkbox>
      <mat-checkbox formControlName="trainees_needed">
        Trainees
      </mat-checkbox>
      <mat-checkbox formControlName="tentative_start_week">
        Tentative Start Date
      </mat-checkbox>
      <mat-checkbox formControlName="close_out_date">
        Close-Out Date
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">2500-8 Reports</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="report_baer_name">
        Report Name
      </mat-checkbox>
      <mat-checkbox formControlName="report_status">
        Report Status
      </mat-checkbox>
      <mat-checkbox formControlName="report_id">
        Report ID
      </mat-checkbox>
      <mat-checkbox formControlName="report_type">
        Report Type
      </mat-checkbox>
      <mat-checkbox formControlName="action_type">
        Action Type
      </mat-checkbox>
      <mat-checkbox formControlName="authorization_status">
        Authorization Status
      </mat-checkbox>
      <mat-checkbox formControlName="submission_date">
        Submission Date
      </mat-checkbox>
      <mat-checkbox formControlName="team_members">
        BAER Team Members
      </mat-checkbox>
      <mat-checkbox formControlName="total_funding_req">
        Total Funding Requested
      </mat-checkbox>
      <mat-checkbox formControlName="ro_auth">
        RO Authorized Funds
      </mat-checkbox>
      <mat-checkbox formControlName="wo_auth">
        WO Authorized Funds
      </mat-checkbox>
      <mat-checkbox formControlName="total_auth">
        Total Authorized Funds
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">BAER Treatment Totals</h3>
    <div class="checkbox-list">
      <mat-checkbox (change)="selectAllTreatments($event)">
        Select All Treatments
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_unit">
        Unit
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_plants">
        Plants
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_ground_cover">
        Ground Cover
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_channel">
        Channel
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_heritage">
        Heritage
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_roads">
        Roads
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_safety">
        Safety
      </mat-checkbox>
      <mat-checkbox formControlName="treatment_monitoring">
        Monitoring
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">Soil Burn Severity Total Acres</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="soil_burn_sev_developed">
        Developed
      </mat-checkbox>
      <mat-checkbox formControlName="soil_burn_sev_unburned">
        Unburned/Very Low
      </mat-checkbox>
      <mat-checkbox formControlName="soil_burn_sev_low">
        Low
      </mat-checkbox>
      <mat-checkbox formControlName="soil_burn_sev_moderate">
        Moderate
      </mat-checkbox>
      <mat-checkbox formControlName="soil_burn_sev_high">
        High
      </mat-checkbox>
    </div>
  </div>
  <div class="options">
    <h3 class="options-header">User Roster</h3>
    <div class="checkbox-list">
      <mat-checkbox formControlName="name">
        Name
      </mat-checkbox>
      <mat-checkbox formControlName="agency">
        Agency
      </mat-checkbox>
      <mat-checkbox formControlName="skills_list">
        BAER Skills
      </mat-checkbox>
      <mat-checkbox formControlName="skills_list_read">
        READ Skills
      </mat-checkbox>
      <mat-checkbox formControlName="skill_level">
        Skill Level
      </mat-checkbox>
      <mat-checkbox formControlName="fire_assignment">
        Fire Assignment Status
      </mat-checkbox>
      <mat-checkbox formControlName="bear_role">
        Positions
      </mat-checkbox>
    </div>
  </div>
  <div class="button-row">
    <button aria-label="Close" class="usa-button usa-button--secondary" mat-dialog-close>Close</button>
    <button aria-label="Update" class="usa-button" (click)="setColumns()">Select Columns</button>
  </div>
</div>